import {
  Card, CardContent, CardHeader,
  CircularProgress, Paper, Container, colors,
  DialogActions, DialogTitle, DialogContent, Dialog, Slider, LinearProgress, Button, Input, Select, Option,
  Divider, Grid, CardActions, FormControl, InputAdornment, TextField, TableSortLabel, TablePagination, Slide,
  TableContainer, Table, TableHead, TableCell, TableRow, TableBody, CardMedia, Tabs, Tab, Backdrop, Typography, Snackbar,
  createMuiTheme, FormGroup, FormControlLabel, Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import SearchIcon from '@material-ui/icons/Search';
import axios from "src/utils/axios";
import React, { useEffect, UseState } from 'react';
import Page from 'src/components/Page';
import { getUser, CreateWareHouseAddress, sc } from 'src/utils/Common';
import MuiAlert from '@material-ui/lab/Alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import moment from 'moment';
import { ThemeProvider } from '@material-ui/styles';
import trLocale from 'date-fns/locale/tr';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useState } from 'react';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};
const defaultUyari = { open: false, aciklama: '', tip: 'success' };


function InvoiceTracking() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = useState(today);
  const [bitisTarihi, setBitisTarihi] = useState(today);
  const [ResponseDataSol, setResponseDataSol] = useState([]);
  const [ResponseDataSolMain, setResponseDataSolMain] = useState([]);
  const [ResponseDataSag, setResponseDataSag] = useState([]);
  const [SolPlus, setSolPlus] = useState(6);
  const [ResponseDataSagMain, setResponseDataSagMain] = useState([]);
  const [sm, setSm] = useState({ entry: 6, exit: 6, return: 6 });
  const [FaturaDurum, setFaturaDurum] = React.useState({
    checkedA: true,
    checkedB: true
  });

  const user = getUser();

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  const handleChangeFaturaDurum = (event) => {

    var A;
    var B;


    if (FaturaDurum.checkedA) {
      A = "Kesilmis";
    } else {
      A = "0";
    }
    if (FaturaDurum.checkedB) {
      B = "Kesilmemis";
    } else {
      B = "0";
    }



    if (event.target.name === "checkedA") {
      if (!event.target.checked) {
        A = "0";
      } else {
        A = "Kesilmis";
      }
    }
    if (event.target.name === "checkedB") {
      if (!event.target.checked) {
        B = "0";
      } else {
        B = "Kesilmemis";
      }
    }

    setResponseDataSol(ResponseDataSolMain.filter(item => sc(item.EFATURA_NO_KONTROL, A)
      || sc(item.EFATURA_NO_KONTROL, B)
    ));

    setResponseDataSag(ResponseDataSagMain.filter(item => sc(item.EFATURA_NO_KONTROL, A)
    || sc(item.EFATURA_NO_KONTROL, B)
  ));

    setFaturaDurum({ ...FaturaDurum, [event.target.name]: event.target.checked });

  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const handleSorgula = () => {
    setLoading(true);
    axios.get('/GetPaslasmaFaturaTakip/' + user.ServiceShopId + '/' + user.UserId + '/' + baslangicTarihi + '/' + bitisTarihi + '/1').then((response) => {
      if (response?.data.length > 0) {
        setResponseDataSol(response.data);
        setResponseDataSolMain(response.data);
      } else {
        setResponseDataSol([]);
        setResponseDataSolMain([]);
      }

      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });
    setLoading(true);
    axios.get('/GetPaslasmaFaturaTakip/' + user.ServiceShopId + '/' + user.UserId + '/' + baslangicTarihi + '/' + bitisTarihi + '/2').then((response) => {
      if (response?.data.length > 0) {
        setResponseDataSag(response.data);
        setResponseDataSagMain(response.data);
      } else {
        setResponseDataSag([]);
        setResponseDataSagMain([]);
      }
      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });

  }
  const handleRowSaveIcon = (id, index) => {
    var EFaturaNo = ResponseDataSol.filter(x => x.ID === id)[0]?.EFATURA_NO;
    if (EFaturaNo === "") {
      EFaturaNo = "|";
    }
    setLoading(true);
    axios.get('/SetPaslasmaFaturaTakip/' + id + '/' + EFaturaNo).then((response) => {
      const newData = [...ResponseDataSol];
      newData[index] = { ...newData[index], Enabled: 0 };
      setResponseDataSol(newData);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });



  }
  const onChange = (e, id) => {
    const newData = [...ResponseDataSol];
    newData[id] = { ...newData[id], EFATURA_NO: e.target.value };
    newData[id] = { ...newData[id], Enabled: 1 };
    setResponseDataSol(newData);


  };

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <CardActions>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap['tr']}
              >
                <KeyboardDatePicker
                  color="primary"
                  size='small'
                  inputVariant="outlined"
                  invalidDateMessage={'Hatalı Tarih Formatı'}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  label="Başlangıç Tarihi"
                  value={baslangicTarihi}
                  onChange={e => handleDateChange(e, 1)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap['tr']}>
                <KeyboardDatePicker
                  color="primary"
                  size='small'
                  inputVariant="outlined"
                  invalidDateMessage={'Hatalı Tarih Formatı'}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  label="Bitiş Tarihi"
                  value={bitisTarihi}
                  onChange={e => handleDateChange(e, 2)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={FaturaDurum.checkedA}
                    onChange={handleChangeFaturaDurum}
                    name="checkedA"
                  />
                }
                label="Faturası Kesilmişler"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={FaturaDurum.checkedB}
                    onChange={handleChangeFaturaDurum}
                    name="checkedB"
                  />
                }
                label="Faturası Kesilmemişler"
              />

            </FormGroup>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<SearchIcon>Sorgula</SearchIcon>}
              onClick={() => handleSorgula()}
            >
              Sorgula
            </Button>
          </CardActions>
          <Divider />
          <Grid container spacing={1}>
            <Grid item xs={sm.entry} sm={sm.entry}>
              <Card>
                <CardHeader title="Sizin Keseceğiniz Faturalar"
                  style={{ height: '10px' }}
                  action={sm.entry === 10 ?
                    <RemoveIcon onClick={() => sm.entry === 10 ? setSm({ entry: 6, exit: 6, return: 0 }) : setSm({ entry: 10, exit: 2, return: 0 })} />
                    :
                    <AddIcon onClick={() => sm.entry === 10 ? setSm({ entry: 6, exit: 6, return: 0 }) : setSm({ entry: 10, exit: 2, return: 0 })} />
                  }
                ></CardHeader>
                <Divider />
                <TableContainer component={Paper} style={{ maxHeight: 700, minHeight: 700, }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Kaydet</TableCell>
                        <TableCell align="left">Paslasma</TableCell>
                        <TableCell align="left">EFaturaNo</TableCell>
                        <TableCell align="left">Malzeme</TableCell>
                        <TableCell align="left">Adet</TableCell>
                        <TableCell align="left">Durum</TableCell>
                        <TableCell align="left">KayıtTarihi</TableCell>
                        <TableCell align="left">Tutar</TableCell>
                        <TableCell align="left">TahsilEdilen</TableCell>
                        <TableCell align="left">Servis</TableCell>
                        <TableCell align="left">Ünvan</TableCell>
                        <TableCell align="left">VergiDairesi</TableCell>
                        <TableCell align="left">VergiNumarası</TableCell>
                        <TableCell align="left">Telefon</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ResponseDataSol?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="left" >
                            {
                              row?.Enabled ? <SaveIcon color="primary"
                                onClick={() => handleRowSaveIcon(row.ID, index)}
                              /> : ""
                            }
                          </TableCell>
                          <TableCell align="left" >
                            {row.PASLASMA_KODU}
                          </TableCell>
                          {/* <CustomTableCell {...{ row, name: "name", onChange }} /> */}
                          <TableCell align="left" >
                            <Input
                              value={row.EFATURA_NO}
                              onChange={e => onChange(e, index)}
                              className={classes.input}
                            />
                          </TableCell>
                          <TableCell align="left" >
                            {row.MALZEME_STOK_NO}
                          </TableCell>
                          <TableCell align="left" >
                            {row.ADET}
                          </TableCell>
                          <TableCell align="left" >
                            {row.DURUM}
                          </TableCell>
                          <TableCell align="left" >
                            {row.KAYIT_TARIHI}
                          </TableCell>
                          <TableCell align="left" >
                            {row.TUTAR}
                          </TableCell>
                          <TableCell align="left" >
                            {row.TAHSIL_EDILEN_TUTAR}
                          </TableCell>
                          <TableCell align="left" >
                            {row.SERVIS}
                          </TableCell>
                          <TableCell align="left" >
                            {row.UNVAN}
                          </TableCell>
                          <TableCell align="left" >
                            {row.VERGI_DAIRESI}
                          </TableCell>
                          <TableCell align="left" >
                            {row.VERGI_NUMARASI}
                          </TableCell>
                          <TableCell align="left" >
                            {row.TELEFON}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={sm.exit} sm={sm.exit}>
              <Card>
                <CardHeader title="Size Kesilecek Faturalar"
                  style={{ height: '10px' }}
                  action={sm.exit === 10 ?
                    <RemoveIcon onClick={() => sm.exit === 10 ? setSm({ entry: 6, exit: 6, return: 0 }) : setSm({ entry: 2, exit: 10, return: 0 })} />
                    :
                    <AddIcon onClick={() => sm.exit === 10 ? setSm({ entry: 6, exit: 6, return: 0 }) : setSm({ entry: 2, exit: 10, return: 0 })} />
                  }
                ></CardHeader>
                <Divider />
                <TableContainer component={Paper} style={{ maxHeight: 700, minHeight: 700, }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Paslasma</TableCell>
                        <TableCell align="left">FişNo</TableCell>
                        <TableCell align="left">EFaturaNo</TableCell>
                        <TableCell align="left">Malzeme</TableCell>
                        <TableCell align="left">Adet</TableCell>
                        <TableCell align="left">Durum</TableCell>
                        <TableCell align="left">KayıtTarihi</TableCell>
                        <TableCell align="left">Servis</TableCell>
                        <TableCell align="left">Telefon</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ResponseDataSag?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="left" >
                            {row.PASLASMA_KODU}
                          </TableCell>
                          <TableCell align="left" >
                            {row.FIS_NO}
                          </TableCell>
                          <TableCell align="left" >
                            {row.EFATURA_NO}
                          </TableCell>
                          <TableCell align="left" >
                            {row.MALZEME_STOK_NO}
                          </TableCell>
                          <TableCell align="left" >
                            {row.ADET}
                          </TableCell>
                          <TableCell align="left" >
                            {row.DURUM}
                          </TableCell>
                          <TableCell align="left" >
                            {row.KAYIT_TARIHI}
                          </TableCell>
                          <TableCell align="left" >
                            {row.SERVIS}
                          </TableCell>
                          <TableCell align="left" >
                            {row.TELEFON}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Page >
  );
}

export default InvoiceTracking;
